import { Model } from "@vuex-orm/core";
import config from "../configs/BuildingLot";
import BuildingOwnerBuildingLot from "./BuildingOwnerBuildingLot";

export default class BuildingLot extends Model {
  static get entity() {
    return "building_lots";
  }
  static fields() {
    return {
      id: this.attr(null),
      building_id: this.attr(null),
      agency_id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      building_owner_building_lots: this.hasMany(BuildingOwnerBuildingLot, "building_lot_id"),
    };
  }
  static get apiConfig() {
    return config;
  }
}
